import { useLocation, useNavigate } from "react-router-dom";

import { goBack } from "@/app/back";
import { useNativeTitle } from "@/app/nativeTitle";
import { useBootstrap } from "@/app/providers";
import headerBackground from "@/assets/header-background.png";

function BackButton({ dark }: { dark: boolean }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <button
      type="button"
      aria-label="ย้อนกลับ"
      onClick={() => {
        goBack(navigate, location.key);
      }}
      className={`flex h-11 w-11 shrink-0 items-center justify-center ${dark ? "text-white" : ""}`}
    >
      <svg viewBox="0 0 24 24" className="h-6 w-6" aria-hidden="true">
        <path
          d="M15 5 8 12l7 7"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

export function ScreenHeader({
  title,
  nativeTitle = title,
}: {
  title: string;
  nativeTitle?: string;
}) {
  const { data } = useBootstrap();

  useNativeTitle(nativeTitle, data.headerMode === "native");

  if (data.headerMode !== "web") {
    return null;
  }

  if (title.length === 0) {
    return (
      <header className="safe-top sticky top-0 z-10 bg-white">
        <div className="flex h-14 items-center px-2">
          <BackButton dark={false} />
        </div>
      </header>
    );
  }

  return (
    <header className="safe-top bg-primary sticky top-0 z-10 overflow-hidden rounded-br-[35px]">
      <img
        src={headerBackground}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute top-0 right-0 h-full opacity-40"
        style={{ aspectRatio: 1.8 }}
      />
      <div className="relative flex h-22 items-center px-4">
        <BackButton dark />
        <h1 className="text-20 ml-1 font-bold text-white">{title}</h1>
      </div>
    </header>
  );
}
